<app-userapi-shared-non-oauth [userApi]="userApi">

  <p translate="INCLUDE_MODALUSERAPI_LABEL_URL" [translateParams]="{ api: userApi.api.name }"></p>

  <div class="flex space-x-2">
    @if (userApi.api.urlPrefix) {
      <div class="my-auto">{{ userApi.api.urlPrefix }}</div>
    }
    <FloatingLabelInput
        id="subdomain"
        [label]="'subdomain'"
        [appColor]="appColor()"
        [(myValue)]="userApi.url"
        (myValueChange)="userApi.configured = !!userApi.publicKey && !!userApi.url">
    </FloatingLabelInput>
    @if (userApi.api.urlPostfix) {
      <div class="my-auto">{{ userApi.api.urlPostfix }}</div>
    }
  </div>

  <p class="mt-8" [innerHTML]="userApi.api.configDescription"></p>

  <FloatingLabelInput
      id="publicKey"
      [label]="(userApi.api.placeholder1 | translate) || 'Token'"
      [appColor]="appColor()"
      [(myValue)]="userApi.publicKey"
      (myValueChange)="userApi.configured = !!userApi.publicKey && !!userApi.url">
  </FloatingLabelInput>

  <div class="mt-8">
    <div class="flex mt-3 step cursor-pointer text-gray-800 dark:text-white" (click)="toggleTest()">
      <div class="flex flex-col justify-center">
        <i [style.color]="isTest() ? appColor() : ''" style="line-height: .65" class="dark:text-white dark:bg-white text-xl {{ isTest() ? 'fa fa-check-square' : ('fa-square ' + (darkMode ? 'fas' : 'far')) }}"></i>
      </div>
      <div class="inline-block ml-4" translate="INCLUDE_MODALUSERAPI_AFAS_TESTENVIRONMENT"></div>
    </div>
    <div class="flex mt-3 step cursor-pointer text-gray-800 dark:text-white" (click)="toggleAccept()">
      <div class="flex flex-col justify-center">
        <i [style.color]="isAccept() ? appColor() : ''" style="line-height: .65" class="dark:text-white dark:bg-white text-xl {{ isAccept() ? 'fa fa-check-square' : ('fa-square ' + (darkMode ? 'fas' : 'far')) }}"></i>
      </div>
      <div class="inline-block ml-4" translate="INCLUDE_MODALUSERAPI_AFAS_ACCEPTENVIRONMENT"></div>
    </div>
  </div>
</app-userapi-shared-non-oauth>
